import { MenuPanelWidgetStyled } from "./styled";
import { ROUTE_PATH } from "utils/constants/routePath";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Buttons } from "components";

const MenuPanelWidget = () => {
  const { i18n } = useTranslation(["home"]);
  const navigate = useNavigate();

  const _handleClickMenu = (e) => {
    navigate(e.path);
  };

  return (
    <MenuPanelWidgetStyled>
      {DATA_MENU_PANEL &&
        DATA_MENU_PANEL.map((e, i) => (
          <div
            key={i}
            className="menu_item_wrap"
            onClick={() => _handleClickMenu(e)}
          >
            <Buttons.MenuPanelItem
              label={i18n.language === "en" ? e.name : e.name_th}
            />
          </div>
        ))}
    </MenuPanelWidgetStyled>
  );
};

const DATA_MENU_PANEL = [
  {
    key: "activities",
    name: "ACTIVITY/NEWS",
    name_th: "ข่าวสารและกิจกรรม",
    path: ROUTE_PATH.ACTIVITIES,
  },
  {
    key: "product_warrantee",
    name: "PRODUCT WARRANTY",
    name_th: "รับประกันสินค้า",
    path: `${ROUTE_PATH.PRODUCT_WARRANTEE}/register`,
  },
  {
    key: "booking",
    name: "FLAGSHIP STORE, BANGKOK",
    name_th: "แฟลกชิปสโตร์ แบงค๊อก",
    path: ROUTE_PATH.BOOKING,
  },
  {
    key: "music_hall",
    name: "MUSIC HALL, BANGKOK",
    name_th: "มิวสิกฮอลล์ แบงค็อก",
    path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/6913fddf8682dc3a88f16b7c`,
  },
  {
    key: "music_practice_room",
    name: "PRACTICE ROOM",
    name_th: "ห้องซ้อมดนตรี",
    path: `${ROUTE_PATH.MUSIC_HALL_AND_PRACTICE}/room`,
  },
  {
    key: "special_points",
    name: "SPECIAL GIFT",
    name_th: "ของรางวัลพิเศษ",
    path: ROUTE_PATH.SPECIAL_POINTS,
  },
];

export default MenuPanelWidget;
